/**
 * SPDX-License-Identifier: MPL-2.0
 * Copyright 2021 (c) Moritz Walker, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2023 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2024 (c) Daniel Littfinski, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import { createAction, Dispatch } from '@reduxjs/toolkit';
import { Software } from 'Api/generated';
import Api from 'Api/Api';

export const SoftwareActionTypes = {
  Query: 'Softwares_Query',
  Queried: 'Softwares_Queried',
  Update: 'Softwares_Update',
  Updated: 'Softwares_Updated',
  Create: 'Softwares_Create',
  Created: 'Softwares_Created',
  Get: 'Softwares_Get',
  Got: 'Softwares_Got',
  Delete: 'Softwares_Delete',
  Deleted: 'Softwares_Deleted',
};

export const SoftwareAction = {
  Query: createAction(SoftwareActionTypes.Query),
  Queried: createAction<Software[]>(SoftwareActionTypes.Queried),
  Update: createAction(SoftwareActionTypes.Update),
  Updated: createAction<Software>(SoftwareActionTypes.Updated),
  Create: createAction(SoftwareActionTypes.Create),
  //Created: createAction<>(SoftwareActionTypes.Created),
  Delete: createAction<number>(SoftwareActionTypes.Delete),
  Deleted: createAction<Software>(SoftwareActionTypes.Deleted),
};

export class SoftwareActions {
  static QuerySoftwares() {
    return function (dispatch: Dispatch) {
      dispatch(SoftwareAction.Query());
      Api.Software.getSoftwares().then((data) => dispatch(SoftwareAction.Queried(data.data)));
    };
  }

  static CreateSoftware(software: Software) {
    return function (dispatch: Dispatch) {
      dispatch(SoftwareAction.Create());
      Api.Software.postSoftware(software)
        .then(() => {
          dispatch(SoftwareAction.Create());
        })
        .catch(() => {
          console.error('Could not CreateSoftware');
        });
    };
  }

  static UpdateSoftware(software: Software) {
    return function (dispatch: Dispatch) {
      dispatch(SoftwareAction.Update());
      if (software.Id != undefined) {
        Api.Software.putSoftware(software.Id, software)
          .then(() => {
            dispatch(SoftwareAction.Updated(software));
          })
          .catch(() => {
            console.error('Could not UpdateSoftware');
          });
      }
    };
  }

  static DeleteSoftware(software: Software) {
    return function (dispatch: Function) {
      if (software.Id === undefined) {
        console.error('Delete Software without ID not possible.');
        return;
      }
      dispatch(SoftwareAction.Delete(software.Id));
      Api.Software.deleteSoftware(software.Id)
        .then(() => {
          dispatch(SoftwareAction.Deleted(software));
        })
        .catch(() => {
          console.error('Could not DeleteSoftware');
        });
    };
  }

  static UploadImg(software: Software, file: File, type: 'logo' | 'icon' | 'screenshot') {
    return function (dispatch: Function) {
      const postData = new FormData();
      postData.append('file', file);
      if (software.Id != undefined) {
        Api.Software.putSoftwareImage(software.Id, type, file).then((res) =>
          dispatch(SoftwareAction.Updated(res.data)),
        );
      }
    };
  }
}
